import {
  formatEuro,
  SALES_MODULES,
  type computeQuote,
  type SalesQuoteInput,
  type SalesQuoteLine,
} from "@klantpunt/shared";

/** Bedrag per maand en prijsregels: in de editor (Platformbeheer) en op de akkoordpagina. */
const SUMMARY_NOTE = new Set(["discount", ...SALES_MODULES.map((m) => m.key)]);

export function QuoteSummary({ totals, input }: { totals: ReturnType<typeof computeQuote>; input: SalesQuoteInput }) {
  const row = (l: SalesQuoteLine) => (
    <tr key={l.key} className={l.total < 0 ? "quote-disc" : undefined}>
      <td>
        {l.label}
        {l.description && SUMMARY_NOTE.has(l.key) && <span className="small muted co-block">{l.description}</span>}
      </td>
      <td className="num">{l.qty ? `${l.qty} × ${formatEuro(l.price)}` : ""}</td>
      <td className="num">{l.total < 0 ? `– ${formatEuro(-l.total)}` : formatEuro(l.total)}</td>
    </tr>
  );
  return (
    <section className="panel co-panel quote-summary" aria-label="Samenvatting">
      <h2 className="label">Per maand, excl. btw</h2>
      <p className="quote-big num" data-testid="quote-monthly">
        {formatEuro(totals.monthly)}
      </p>
      <p className="muted small">
        {totals.discount > 0 && (
          <>
            Lijstprijs <s>{formatEuro(totals.subtotal)}</s> ·{" "}
          </>
        )}
        Eerste jaar {formatEuro(totals.firstYear)} · {input.termMonths} maanden
      </p>
      <table className="it quote-lines" aria-label="Prijsregels">
        <tbody>
          {totals.monthlyLines.map(row)}
          {totals.monthlyDiscount && row(totals.monthlyDiscount)}
          {totals.onceLines.length > 0 && (
            <tr>
              <th colSpan={3} scope="rowgroup" className="label">
                Eenmalig
              </th>
            </tr>
          )}
          {totals.onceLines.map(row)}
        </tbody>
      </table>
      <dl className="kv quote-totals">
        <dt>Btw 21%</dt>
        <dd className="num">{formatEuro(totals.vat)}</dd>
        <dt>Eenmalig</dt>
        <dd className="num">{formatEuro(totals.once)}</dd>
      </dl>
    </section>
  );
}
